import http from "@/shared/services/http";
import {buildRequestHeader} from "@/shared/services/helper/utils";

export const getChecking = (ladingCode: string) => http.get(`v1/customer/checkings`, {params: {ladingCode}});

export async function getTracking(ladingCode: string) {
    return fetch(process.env.VUE_APP_BASE_API + `v1/customer/tracking?lading-code=` + ladingCode, {
        method: 'GET',
        headers: new Headers(
            buildRequestHeader(false as any)
        )
    })
}